import { DtArea } from '@ow/ditto-core'

const { validation, transformer, filterSpec } = DtArea

export { default as Render } from './render'
export { default as Filter } from './filter'
// export { default as validation } from './validation'
export { validation, transformer, filterSpec }
// export { default as Filter } from './render'
// export { filterSpec } from './config'
// export { default as transformer } from './transformer'
